export class Maestro_RolesDominio {
    id: number;
    rol: string;
    activo: boolean;
    rolAdministrador: boolean;
    mostrarAliado: boolean;
    mostrarCanal: boolean;
    rolMulticonsulta: boolean;
    editarProductoCliente: boolean;
    eliminarProductoCliente: boolean;
}